import { Avatar, Box, Stack, Typography } from "@mui/material";
import React from "react";
import styles from "../../../../assets/styles/events/createEvent.styles";

const MemberTab = ({ members }) => {
	return (
		<>
			<Box>
				{members?.map((member, index) => (
					<Stack direction="row" sx={styles.memberStack} key={index}>
						<Avatar
							sx={styles.memberAvatar}
							src={member?.event_member?.profile_image}
						/>
						<Stack sx={styles.memberNameStack} gap="5px">
							<Typography component="h4">
								{member?.event_member?.full_name}
							</Typography>
							<Typography component="label">
								{member?.event_member?.email}
							</Typography>
						</Stack>
					</Stack>
				))}
			</Box>
		</>
	);
};

export default MemberTab;
